/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { SerializedLegacyFilters } from 'cio/types/conditions/legacy-filter';
import { Filters } from 'cio/utils/filters';
import CampaignModel from 'cio/models/campaign';

interface VisualWorkflowBuilderWorkflowActionActionConditionsArgs {
  conditions: SerializedLegacyFilters | Filters;
  description: string;
  campaign: CampaignModel;
}

export default class VisualWorkflowBuilderWorkflowActionActionConditions extends Component<VisualWorkflowBuilderWorkflowActionActionConditionsArgs> {
  get conditions() {
    return this.args.conditions ?? [];
  }
}
